<template>
	<div>
		<DetailTitle :title="'총 ' + waitingCount + '회 예약 대기'" />

		<DetailCardContainer>
			<ReservationWaitingListItem
				v-for="item in userReservationWaitingList"
				:key="item.ID"
				:item="item"
				@initRender="initRender"
			/>
		</DetailCardContainer>

		<InfiniteLoading ref="infiniteLoading" @infinite="infinite" />
	</div>
</template>

<script>
import DetailTitle from '@/components/common/DetailTitle';
import DetailCardContainer from '@/components/common/DetailCardContainer';
import InfiniteLoading from '@/components/common/InfiniteLoading';
import ReservationWaitingListItem from './ReservationWaitingListItem';

export default {
	components: {
		DetailTitle,
		DetailCardContainer,
		InfiniteLoading,
		ReservationWaitingListItem,
	},
	data() {
		return {
			page: 1,
		};
	},
	computed: {
		userId() {
			return this.$store.getters['userStore/userId'];
		},
		userReservationWaitingList() {
			return this.$store.getters['reservationStore/userReservationWaitingList'];
		},
		waitingCount() {
			const result = this.userReservationWaitingList.filter(
				el => el.STATUS_CODE === '1',
			);
			return result ? result.length : 0;
		},
	},
	created() {
		this.initUserReservationWaitingList();
	},
	methods: {
		async fetchUserReservationWaitingList() {
			const payload = {
				page: this.page,
				userId: this.userId,
			};

			return await this.$store.dispatch(
				'reservationStore/getUserReservationWaitingList',
				payload,
			);
		},
		initUserReservationWaitingList() {
			this.$store.dispatch('reservationStore/initUserReservationWaitingList');
		},
		infinite(state) {
			this.fetchUserReservationWaitingList().then(({ data }) => {
				if (data.code !== '00000' || data.page > data.totalPage) {
					this.page--;
					state.complete();
				}
				if (data.page <= data.totalPage) {
					this.page++;

					/**
					 * 데이터 가져오는 속도가 빨라서
					 * 스크롤시 무한 스크롤링 로딩 아이콘 노출 시간이 짧아서 보이지 않음.
					 * 임의로 가져오는 속도 늦춤.
					 */
					setTimeout(() => state.loaded(), 400);
				}
			});
		},
		initRender() {
			this.page = 1;
			this.initUserReservationWaitingList();
			this.$refs.infiniteLoading.resetInfiniteLoading();
		},
	},
};
</script>
